import backend from '@justgiving/i18next-dynamic-import-backend';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const SUPPORTED_LANGUAGES = ['en', 'en-GB', 'en-US', 'en-AU'];

const getLocaleFromQuerystring = (): string | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  const queryLocale = new URLSearchParams(window.location.search).get('locale');
  if (queryLocale && SUPPORTED_LANGUAGES.includes(queryLocale)) {
    return queryLocale;
  }

  return undefined;
};

const getLocaleFromNavigator = (): string | undefined => {
  if (typeof navigator === 'undefined') {
    return undefined;
  }

  const browserLocale = navigator.language;
  if (SUPPORTED_LANGUAGES.includes(browserLocale)) {
    return browserLocale;
  }

  const languagePrefix = browserLocale.split('-')[0];
  if (SUPPORTED_LANGUAGES.includes(languagePrefix)) {
    return languagePrefix;
  }

  return undefined;
};

const simpleLanguageDetector = {
  type: 'languageDetector' as const,
  detect: () => getLocaleFromQuerystring() || getLocaleFromNavigator() || 'en',
  init: () => undefined,
  cacheUserLanguage: () => undefined,
};

i18n
  .use(initReactI18next)
  .use(
    backend(
      lang =>
        import(
          /* webpackChunkName: "lang/[request]" */ `../lang/${lang}.json5`
        ),
      { loadDefault: true }
    )
  )
  .use(simpleLanguageDetector)
  .init({
    supportedLngs: ['en', 'en-GB', 'en-US', 'en-AU'],
    fallbackLng: 'en',
    keySeparator: false,

    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['querystring', 'navigator'],
      lookupQuerystring: 'locale',
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;
